import client from '../client';

export const CREATE_GOLF_SCHOOL_CLASS = 'CREATE_GOLF_SCHOOL_CLASS';
export const EDIT_GOLF_SCHOOL = 'EDIT_GOLF_SCHOOL';
export const EDIT_GOLF_SCHOOL_CLASS = 'EDIT_GOLF_SCHOOL_CLASS';
export const GET_GOLF_SCHOOL_CLASSES = 'GET_GOLF_SCHOOL_CLASSES';
export const GET_GOLF_SCHOOLS = 'GET_GOLF_SCHOOLS';

export function getGolfSchools() {
  return {
    type: GET_GOLF_SCHOOLS,
    promise: client.get('schools/all'),
  };
}

export function editSchool(schoolId, data) {
  return {
    type: EDIT_GOLF_SCHOOL,
    promise: client.put(`schools/${schoolId}`, data),
    schoolId,
  };
}

export function createClass(schoolId, data) {
  return {
    type: CREATE_GOLF_SCHOOL_CLASS,
    promise: client.post(`schools/${schoolId}/classes`, data),
    schoolId,
  };
}

export function editClass(schoolId, classId, data) {
  return {
    type: EDIT_GOLF_SCHOOL_CLASS,
    promise: client.put(`schools/${schoolId}/classes/${classId}`, data),
    schoolId,
    classId,
  };
}

export function deleteClass(schoolId, classId) {
  return {
    type: EDIT_GOLF_SCHOOL_CLASS,
    promise: client.delete(`schools/${schoolId}/classes/${classId}`),
    schoolId,
    classId,
  };
}

export function fetchClasses(schoolId, data) {
  return {
    type: GET_GOLF_SCHOOL_CLASSES,
    promise: client.get(`schools/${schoolId}/classes`, data),
  };
}



// WEBPACK FOOTER //
// ./src/golf-schools/actions.js